import {
  GET_AUTHOR,
  GET_AUTHOR_SUCCESS,
  GET_AUTHOR_ERROR } from "../../constants/actionTypes";
import initialState from "../../config/initialState";

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_AUTHOR: {
      return {
        ...state,
        isLoading: true,
        isFinished: false,
        isError: false,
        error: null,
      };
    }

    case GET_AUTHOR_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        data: action.payload,
      };
    }

    case GET_AUTHOR_ERROR: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        isError: true,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/author/reducers/authors.js